<div class="aya-progress" *ngIf="hasContent">
  <button type="button" class="aya-progress-header" (click)="toggle()" [attr.aria-expanded]="open">
    <i class="fal fa-spinner-third aya-progress-spinner" *ngIf="isActive"></i>
    <i class="fal fa-check aya-progress-check" *ngIf="!isActive"></i>
    <span class="aya-progress-label">{{ activeLabel }}</span>
    <i class="fal fa-chevron-down aya-progress-chevron" [class.open]="open"></i>
  </button>

  <div class="aya-progress-body" [class.open]="open">
    <div class="aya-progress-inner">
      <ol class="aya-progress-phases" *ngIf="phases.length">
        <li *ngFor="let phase of phases" [class.active]="phase.state === 'active'">
          <i class="fal fa-check" *ngIf="phase.state === 'done'"></i>
          <span class="skipped" *ngIf="phase.state === 'skipped'">–</span>
          <i class="fal fa-spinner-third spin" *ngIf="phase.state === 'active'"></i>
          <span class="pending-dot" *ngIf="phase.state === 'pending'"></span>
          <span>{{ phase.label }}</span>
        </li>
      </ol>

      <ul class="aya-progress-searches" *ngIf="showSearchList">
        <li *ngFor="let step of searchSteps">
          <i class="fal fa-search"></i>
          <span>{{ step.query || step.label }}</span>
        </li>
      </ul>

      <p class="aya-progress-status" *ngIf="!phases.length && statusLine">
        <i class="fal fa-search pulse"></i>
        <span>{{ statusLine }}</span>
      </p>
    </div>
  </div>
</div>
